<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="园区/社区" prop="parkId" viewonly>
                        <Select v-model="info.parkId" transfer>
                            <Option
                                v-for="item in parkList"
                                :value="item.id"
                                :key="item.id"
                            >
                                {{ item.parkName }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="楼栋号" prop="floorName" viewonly>
                        <Input v-model="info.floorName" placeholder disabled>
                            <span slot="append">栋</span>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="房间号" prop="houseNum" viewonly>
                        <Input v-model="info.houseNum" type="number" />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="房间代码" prop="houseNo" viewonly>
                        <Input v-model="info.houseNo" placeholder="例如A-1-3" />
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="建筑面积" prop="buildArea" viewonly>
                        <input-number
                            v-model="info.buildArea"
                            placeholder
                            :min="0"
                        >
                            <span slot="append">㎡</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="单价" prop="unitPrice" viewonly>
                        <input-number
                            v-model="info.unitPrice"
                            placeholder
                            viewonly
                            :min="0"
                        >
                            <span slot="append">元/㎡/月</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="租金" prop="rent" viewonly>
                        <input-number v-model="info.rent" placeholder :min="0">
                            <span slot="append">元/月</span>
                        </input-number>
                    </FormItem>
                </Col>
                <!-- 单价区间 -->
                <Col span="12">
                    <FormItem label="单价区间" prop="rentInterval">
                        <rent-interval :info="info" />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="拆分为" prop="splitNum">
                        <input-number
                            v-model="info.splitNum"
                            :allowDecimal="false"
                            :min="1"
                            placeholder
                            @on-blur="splitNumChange"
                        >
                            <span slot="append">间房</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="拆分后房号" prop="splitHouseNum">
                        <Select
                            v-model="splitHouseNum"
                            disabled
                            multiple
                            placeholder
                        >
                            <Option
                                v-for="item in info.houses"
                                :value="item.houseNum"
                                :key="item.houseNum"
                            >
                                {{ item.houseNum }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <div
                class="split-room"
                v-for="(item, index) in info.houses"
                :key="item.houseNum"
            >
                <split-room :info="item" :index="index" />
            </div>
        </Form>
    </div>
</template>
<script>
import { multiply } from '@/views/common/u-contract'
import {
    assetsHouseList,
    assetsHouseSplit,
    assetsHouseView,
} from '@/api/assets'
import { assetsParkRootList } from '@/api/configuration'
import RentMode from '_vc/fields/rent-mode'
import RentInterval from '_vc/fields/rent-interval'
import RoomConfig from '_vc/fields/room-config'
import SplitRoom from '_vc/fields/split-room'

export default {
    name: 'RoomSplitFrom',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        parkId: {
            type: [String, Number],
            default: '',
        },
        floorId: {
            type: [String, Number],
            default: '',
        },
        floorName: {
            type: String,
            default: '',
        },
        floorNum: {
            type: [String, Number],
            default: 0,
        },
    },

    components: { RentMode, RoomConfig, RentInterval, SplitRoom },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                parkId: this.parkId, // 园区/社区
                floorName: this.floorName, //  楼栋
                floorId: this.floorId, // 楼栋id
                floorNum: this.floorNum, // 楼层
                houseNum: '', //房间号
                houseNo: '', //  房间代码
                buildArea: '', // 建筑面积
                unitPrice: '', // 单价
                minPrice: '', //(最低单价(分))
                maxPrice: '', //(最高单价(分))
                rent: '', // 租金
                splitNum: '', // 拆为几间房
                houseStatus: '', //房间状态
                houses: [], // 拆分房间
                ver: '',
            },
            parkList: [], // 园区列表
            houseList: [], // 房间列表
            rentMode: '', //交租方式
            addRooms: 0,
            splitHouseNum: [], //拆分后房号
            dict: {
                parkType: this.$dict.NULL,
                decorationType: this.$dict.NULL,
            },
        }
    },

    computed: {
        ruleValidate() {
            return {
                splitNum: [{ required: true, message: '拆分数必填' }],
            }
        },
    },

    methods: {
        // 关闭 alter
        closeAlter() {
            this.alterShow = false
        },
        // 最低价格更改，触发校验
        minPriceChange() {
            this.$refs.info.validate()
        },
        // 格式化房间列表 id 房间id；text 房号
        formateHouseList(list) {
            const newList = []
            list.forEach((v) => {
                newList.push({
                    id: v.id,
                    text: v.houseNum,
                    buildArea: v.buildArea,
                })
            })
            newList.sort((a, b) => (a.text > b.text ? 1 : -1))
            return newList
        },

        // 房间详情格式化
        formateHouseView(data) {
            data.unitPrice = data.unitPrice ? data.unitPrice / 100 : 0
            data.rent = data.rent ? data.rent / 100 : 0
            data.minPrice = data.minPrice ? data.minPrice / 100 : 0
            data.maxPrice = data.maxPrice ? data.maxPrice / 100 : 0
            data.splitNum = ''
            data.houses = []
            Object.keys(this.info).forEach(
                (name) => (this.info[name] = data[name])
            )
        },

        // 选中房间发生改变-建筑面积更改
        chooseHouseChange() {
            let buildArea = 0
            this.info.houseIds.forEach((v) => {
                const house = this.houseList.find((p) => p.id === v)
                if (house) {
                    buildArea += house.buildArea ? house.buildArea - 0 : 0
                }
            })
            this.info.buildArea = buildArea
        },
        // 房间拆分间数-失焦
        splitNumChange() {
            const num = this.info.splitNum - 0
            // 是否更改
            if (num === this.info.houses.length) {
                return
            }
            // 为0 或 空
            const splitHouseNum = []
            const houses = []
            const build = this.calcBuildArea(this.info.buildArea, num)
            for (let i = 0; i < num; i++) {
                const houseNum =
                    this.info.houseNum + '-' + this.formatZero(i + 1, 2)
                const buildArea =
                    num === 1 || i < num - 1 ? build.other : build.last
                splitHouseNum.push(houseNum)
                houses.push({
                    houseNum,
                    buildArea,
                    unitPrice: '',
                    rent: '',
                    minPrice: '',
                    maxPrice: '',
                })
            }

            this.splitHouseNum = splitHouseNum
            this.info.houses = houses
        },
        // 计算建筑面积平分
        calcBuildArea(area, num) {
            const build = {
                other: 0,
                last: 0,
            }
            area -= 0
            if (area === 0) {
            } else if (num === 1) {
                build.other = area
            } else {
                build.other = Math.floor((area / num) * 100) / 100
                build.last =
                    (multiply(area) - multiply(build.other) * (num - 1)) / 100
            }
            return build
        },
        // 不足两位补0
        formatZero(num, len) {
            if (String(num).length > len) return num
            return (Array(len).join(0) + num).slice(-len)
        },
    },
    watch: {},

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = [
            {
                type: 'primary',
                name: 'confirm',
                text: '确定',
            },
            {
                type: 'default',
                name: 'cancel',
                text: '取消',
            },
        ]
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                assetsParkRootList(),
                assetsHouseView(this.id),
                assetsHouseList({
                    pageNo: 1,
                    pageSize: 999,
                    parkId: this.info.parkId,
                    floorId: this.info.floorId,
                    floorNum: this.info.floorNum,
                    houseStatus: '1',
                }),
                this.$dict.get(['park_type', 'decoration_type']),
            ])
                .then((args) => {
                    var [park, view, house, group] = args

                    Object.assign(this.dict, group)
                    this.houseList = this.formateHouseList(house.data.page.list)
                    this.formateHouseView(view.data.entity)
                    this.parkList = park.data.list
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    const formData = this.info
                    const data = {}
                    data.id = formData.id
                    data.floorId = formData.floorId
                    data.floorNum = formData.floorNum
                    data.houseNum = formData.houseNum
                    data.houseNo = formData.houseNo
                    data.buildArea = formData.buildArea
                    data.ver = formData.ver
                    data.unitPrice = multiply(formData.unitPrice)
                    data.rent = multiply(formData.rent)
                    data.houseStatus = formData.houseStatus
                    data.houses = []
                    formData.houses.forEach((v) => {
                        data.houses.push({
                            houseNum: v.houseNum,
                            buildArea: v.buildArea,
                            unitPrice: multiply(v.unitPrice),
                            rent: multiply(v.rent),
                            minPrice: multiply(v.minPrice),
                            maxPrice: multiply(v.maxPrice),
                        })
                    })
                    data.houses = JSON.stringify(data.houses)
                    return assetsHouseSplit(data)
                })
                .then((res) => {
                    this.$Message.success('房间拆分成功')
                })
                .catch((err) => {
                    if (err && err.msg) this.$Message.error(err.msg)

                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
